export const redirectTo = url => window.location = url;